(() => {
  if (customElements.get('dlt-product-film')) return;
  customElements.define('dlt-product-film', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const video = this.querySelector('video');
      if (!video) return;
      const play = this.querySelector('[data-film-play]');
      const sound = this.querySelector('[data-film-sound]');
      const status = this.querySelector('[role="status"]');
      const update = () => {
        const playing = !video.paused && !video.ended;
        const audible = !video.muted && video.volume > 0;
        play.textContent = playing ? 'Pausar' : 'Reproduzir';
        play.setAttribute('aria-label', playing ? 'Pausar vídeo' : 'Reproduzir vídeo');
        play.setAttribute('aria-pressed', String(playing));
        sound.textContent = audible ? 'Silenciar' : 'Ativar som';
        sound.setAttribute('aria-label', audible ? 'Silenciar vídeo' : 'Ativar som do vídeo');
        sound.setAttribute('aria-pressed', String(audible));
      };
      video.muted = true;
      this.querySelector('.dlt-pdp-full-width-video__controls').hidden = false;
      play.addEventListener('click', async () => {
        if (!video.paused) { video.pause(); return; }
        try { await video.play(); status.textContent = ''; }
        catch (error) { if (error.name !== 'AbortError') status.textContent = 'Não foi possível reproduzir. Tente os controles do vídeo.'; }
      }, {signal});
      sound.addEventListener('click', () => { video.muted = !video.muted; if (!video.muted && video.volume === 0) video.volume = 1; }, {signal});
      ['play','pause','ended','volumechange'].forEach(name => video.addEventListener(name, update, {signal}));
      this.visibility = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); }, {threshold:0});
      this.visibility.observe(this);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); }, {signal});
      update();
    }
    disconnectedCallback() { this.querySelector('video')?.pause(); this.controller?.abort(); this.visibility?.disconnect(); }
  });
})();
